import React, { useContext } from 'react';
import { Input, Select } from 'antd';
import update from 'immutability-helper';
import ComponentHeader from 'common/components/ComponentHeader';
import AttributePicker from 'common/components/AttributePicker';
import { AttributesContext, BulkAddUsersAttributesContext } from 'common/contexts';
import {
  BULK_ATTRIBUTE_NAME_IND,
  BULK_ATTRIBUTE_VALUE_IND,
  GENDER_ATTRIBUTE_NAME,
  NAME_ATTRIBUTE_NAME,
  PEER_CLASS_ATTRIBUTE_NAME,
  PHONE_ATTRIBUTE_NAME,
} from 'common/constants/constants';
import {
  TIME_DATATYPE,
  PICTURE_DATATYPE,
  UID_DATATYPE,
  FILE_DATATYPE,
} from 'common/constants/datatypes';
import { bulkAddUsersPageHeaderStyles } from './styles';

const BulkAddAttributesContainer = () => {
  const { attributes } = useContext(AttributesContext);
  const { bulkAttributes, setBulkAttributes } = useContext(BulkAddUsersAttributesContext);
  const addNewBulkAttribute = newAttribute => {
    const bulkAttributeTypes = bulkAttributes.map(
      attribute => attribute[BULK_ATTRIBUTE_NAME_IND]
    );
    const attributeInd = bulkAttributeTypes.indexOf(newAttribute[BULK_ATTRIBUTE_NAME_IND]);
    if (attributeInd !== -1) {
      bulkAttributes[attributeInd] = newAttribute;
      setBulkAttributes([...bulkAttributes]);
    } else {
      setBulkAttributes([...bulkAttributes, newAttribute]);
    }
  };

  const handleAttributeChange = (value, index) => {
    if (!value) {
      // Remove attribute dropdown
      const updatedBulkAttributes = update(bulkAttributes, { $splice: [[index, 1]] });
      setBulkAttributes(updatedBulkAttributes);
    } else {
      // Replace attribute value
      const updatedBulkAttributes = update(bulkAttributes, {
        [index]: {
          [BULK_ATTRIBUTE_VALUE_IND]: { $set: value },
        },
      });
      setBulkAttributes(updatedBulkAttributes);
    }
  };

  return (
    <>
      <ComponentHeader styles={bulkAddUsersPageHeaderStyles}>
        <div style={{ textTransform: 'uppercase' }}>Bulk Attributes</div>
      </ComponentHeader>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '10px' }}>
        {bulkAttributes.map(([genre, section, attributeType, attribute], index) => (
          <div key={attributeType} style={{ margin: '10px' }}>
            <div style={{ textTransform: 'capitalize' }}>{attributeType.replace(/_/g, ' ')}</div>
            {attributes.genres
              .find(g => g.name === genre)
              .sections.find(s => s.name === section)
              .attribute_types.find(at => at.name === attributeType).listable ? (
                <Select
                  allowClear
                  getPopupContainer={e => e}
                  onChange={value => handleAttributeChange(value, index)}
                  style={{ width: '100%' }}
                  type="text"
                  value={attribute}
                >
                  {attributes.genres
                    .find(g => g.name === genre)
                    .sections.find(s => s.name === section)
                    .attribute_types.find(at => at.name === attributeType)
                    .attributes.map(a => (
                      <Select.Option key={a.value}>{a.value}</Select.Option>
                    ))}
                </Select>
              ) : (
                <Input
                  onChange={event =>
                    handleAttributeChange(event.target.value, index)}
                  placeholder={attributeType}
                />
              )}
          </div>
        ))}
        <div style={{ margin: '10px' }}>
          <AttributePicker
            showUnlistable
            attributeTypesToExclude={[
              GENDER_ATTRIBUTE_NAME,
              NAME_ATTRIBUTE_NAME,
              PEER_CLASS_ATTRIBUTE_NAME,
              PHONE_ATTRIBUTE_NAME,
            ]}
            attributes={attributes}
            datatypesToExclude={[TIME_DATATYPE, PICTURE_DATATYPE, UID_DATATYPE, FILE_DATATYPE]}
            onChange={addNewBulkAttribute}
            placeholder="+ Add Attribute"
          />
        </div>
      </div>
    </>
  );
};

export default BulkAddAttributesContainer;
